// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1LGQ5","sendOtp":"AuthorizeToLogin_sendOtp__1iNkV"};